module.exports = __webpack_public_path__ + "img/video.08fea82f.svg";